<template>
  <h2
    class="boss-title-setting"
    data-test="header-title"
  >
    <breadcrumbs :breadcrumbs="breadcrumbs" />
    {{ title }}
  </h2>
</template>

<script>
import Breadcrumbs from '@/components/atoms/Breadcrumbs'
export default {
  components: {
    Breadcrumbs
  },
  props: {
    title: {
      type: String,
      required: true
    },
    breadcrumbs: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>
